<template>
  <div class="parent">
    <div class="divTitle" :style="{ color: titleColor }">
      <img :src="prevImg" class="imgPrev" />{{ title
      }}<img :src="nextImg" class="imgNext" />
    </div>
    <div class="divSubTitle" :style="{ color: subTitleColor }" v-if="subTitle">
      {{ subTitle }}
    </div>
    <div class="divFontBg" :style="{ color: fontBgColor }">{{ fontBg }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    titleColor: {
      type: String,
      default: "rgba(7,46,124,1)",
    },
    subTitleColor: {
      type: String,
      default: "rgba(109,109,109,1)",
    },
    prevImg: {
      type: String,
      default: require("./../img/title_prev.png"),
    },
    nextImg: {
      type: String,
      default: require("./../img/title_next.png"),
    },
    fontBg: {
      type: String,
      default: "",
    },
    fontBgColor: {
      type: String,
      default: "rgba(10,226,242,1)",
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../scss/titleWidge.scss";
</style>
